import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid, makeStyles } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import { ButtonActions, ButtonActionsWhite } from 'Components/UI';
import { Header } from 'Components/Common';
import ShareNotePeople from './ShareNotePeople';
import { useTranslation } from 'react-i18next';
import { useAtom } from 'jotai';
import {
  ticketAtom,
  shareNoteAtom,
  listProductsToPayAtom,
  amountToPayAtom,
  activePersonalizedTipsAtom,
} from 'Atoms/Ticket';

const useStyles = makeStyles((theme) => ({
  root: { ...theme.containerGrid, a: { borderRadius: '33px' } },
  title: { ...theme.title, margin: '4rem 0 1rem 0' },
  button: {
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    color: '#fff',
    width: '42px',
    minWidth: '42px',
    height: '42px',
    fontFamily: 'FuturaStdBold',
    fontSize: '18px',
    margin: '0 8px',
    borderRadius: '5px',
    padding: '5px',
    '&:focus': {
      backgroundColor: '#fff',
      color: theme.palette.primary.main,
    },
  },
  link: {
    textDecoration: 'none',
    background: 'none',
    '-webkit-tap-highlight-color': 'transparent',
    '&:focus, &:hover, &:visited, &:link, &:active': {
      textDecoration: 'none',
      backgroundColor: 'none',
    },
  },
}));

const ShareNote = () => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const [ticket] = useAtom(ticketAtom);

  const { id, order } = ticket || {};
  const splitByProduct = order?.payments?.done ? order.payments.done.byProduct : true
  
  const [, setShareNote] = useAtom(shareNoteAtom);
  const [amountToPay] = useAtom(amountToPayAtom);

  const [sharePerPeople, setSharePerPeople] = useState(false);
  const [listProductsToPay] = useAtom(listProductsToPayAtom);
  const history = useHistory();
  const [disabledHover, setDisabledHover] = useState(true);
  const [activePersonalizedTips, setActivePersonalizedTips] = useAtom(
    activePersonalizedTipsAtom,
  );

  const delayRedirect = (e, to, selected, value) => {
    e.preventDefault();
    setDisabledHover(false);
    setShareNote({ selected, value });
    setTimeout(() => history.push(to), 500);
  };
  const handleTouchStart = () => {};

  return (
    <>
      <Header
        title={t('my_ticket')}
        actions={{
          prev: {
            icon: 'return',
            label: t('go_back'),
            path: `/ticket/:${id}`,
          },
        }}
      ></Header>
      <Grid
        container
        justifyContent="center"
        alignContent="center"
        alignItems="center"
        className={classes.root}
      >
        <Grid item className={classes.title}>
          {t('share_bill')}
          {t('!')}
        </Grid>
        <Grid item xs={11}>
          {!sharePerPeople ? (
            <div
              onClick={(e) => {
                setSharePerPeople(true);
                setDisabledHover(false);
              }}
              //onTouchStart={handleTouchStart()}
            >
              <ButtonActionsWhite
                label={t('share_bill_per_people')}
                styles={{
                  background: 'backgroundWhite',
                  label: 'labelDark',
                  radius: 'radius33',
                  hover: disabledHover,
                }}
                color="default"
              />
            </div>
          ) : (
            <ButtonActions
              label=""
              styles={{
                background: 'backgroundBlue',
                label: 'labelWhite',
                radius: 'radius33',
              }}
              color="default"
            >
              <ShareNotePeople id={id} />
            </ButtonActions>
          )}
          <Link
            to={{}}
            onClick={(e) =>
              delayRedirect(
                e,
                `/ticket/:${id}/share/calculator`,
                'perAmount',
                amountToPay,
              )
            }
            className={classes.link}
          >
            <ButtonActionsWhite
              label={t('share_bill_per_amount')}
              styles={{
                background: 'backgroundWhite',
                label: 'labelDark',
                radius: 'radius33',
                hover: disabledHover,
              }}
              color="default"
            />
          </Link>
          { splitByProduct && <Link
            to={{}}
            onClick={(e) =>
              delayRedirect(
                e,
                `/ticket/:${id}/share/perProducts`,
                'perProduct',
                [],
              )
            }
            className={classes.link}
          >
            <ButtonActionsWhite
              label={t('share_bill_per_product')}
              styles={{
                background: 'backgroundWhite',
                label: 'labelDark',
                radius: 'radius33',
                hover: disabledHover,
              }}
              color="default"
            />
          </Link>}
        </Grid>
      </Grid>
    </>
  );
};

ShareNote.propTypes = {};

export default ShareNote;
